import AvartarHeader from "../fragments/AvartarHeader";
import AvartarLogoutBtn from "../fragments/AvartarLogoutBtn";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import LogoutConfirmModal from "../modals/LogoutConfirmModal";
import socketService from "../../services/socketService";
import { authHandler, kitchenHandler, posHandler } from "../../redux/handlers";
import { useKitchen } from "./KitchenContext";
export default function KitchenHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const { businessSlug } = useParams();
  const location = useLocation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [currentKitchenName, setCurrentKitchenName] = useState("false");
  const { kitchenCount } = useKitchen();
  const kitchenID = localStorage.getItem("branchKitchenId");
  const branchId = localStorage.getItem("branchId");
  const [currentTimerAVG, setCurrentTimerAVG] = useState("00:00");
  const [currentTimerMAX, setCurrentTimerMAX] = useState("00:00");
  const handleLogout = async () => {
    setShowLogoutModal(false);
    await dispatch(authHandler.logout(businessSlug));
    await dispatch(kitchenHandler.logoutKitchen(businessSlug, Number(kitchenID)));
    localStorage.removeItem("email");
    localStorage.removeItem("branchId");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("branchKitchenId");
    localStorage.removeItem("branchPOSId");
    socketService.disconnect();
    navigate(`/${businessSlug}/login`, { replace: true });
  };
  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };
  const handleClickLogout = () => {
    setShowLogoutModal(true);
  };
  const timeFormat = (totalSeconds) => {
    if (totalSeconds < 60) {
      const minutes = 0;
      const seconds = Math.round(totalSeconds);

      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    } else {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = Math.round(totalSeconds % 60);

      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
  };
  useEffect(() => {
    async function fetchBranchInfo() {
      const res = await dispatch(posHandler.getBranchKitchen(businessSlug, branchId));
      const currentKitchenInfo = res.filter((item) => item.id === Number(kitchenID));
      setCurrentKitchenName(currentKitchenInfo?.[0]?.name);
    }
    fetchBranchInfo();
  }, [dispatch, businessSlug, branchId, kitchenID]);
  useEffect(() => {
    async function getTimer() {
      const timer = await dispatch(kitchenHandler.getKitchenTimer(businessSlug, branchId, kitchenID));

      if (timer?.completed_time_average != null) {
        // dayjs.extend(duration);
        // const durAVG = dayjs.duration(timer?.completed_time_average, "seconds");
        // const durMAX = dayjs.duration(timer?.completed_time_max, "seconds");
        // const minAVG = durAVG.minutes();
        // const secondsAVG = durAVG.seconds();
        // const minMAX = durMAX.minutes();
        // const secondsMAX = durMAX.seconds();

        setCurrentTimerAVG(timeFormat(timer?.completed_time_average));
        setCurrentTimerMAX(timeFormat(timer?.completed_time_max));
      }
    }
    getTimer();
  }, [branchId, businessSlug, dispatch, kitchenID]);
  return (
    <>
      <div className="fixed w-full rounded-b-[min(0.39vw,4px)] h-[min(7.91vw,81px)] shadow-md bg-[#FFF] py-[min(1.46vw,15px)] pl-[min(2.05vw,21px)] pr-[min(1.56vw,16px)] flex justify-between z-[100]">
        <div className="flex">
          <img className="object-contain aspect-square h-fit rounded-full w-[min(4.98vw,51px)] mr-[min(4.69vw,48px)]" src="/img/logo-3.png" alt="" />
          <div className="flex gap-[min(1.27vw,13px)]">
            <div className="flex flex-col shadow-sm justify-center gap-[min(0.59vw,6px)] min-w-[min(10.45vw,107px)] h-[min(5.66vw,58px)]  text-12 rounded-[min(0.49vw,5px)] px-[min(1.17vw,12px)]">
              <div className="text-[var(--color-grey-2)]">รอการจัดเตรียม</div>
              <div className="flex justify-between items-baseline ">
                <div className="flex items-baseline gap-[min(1.27vw,13px)]">
                  <img className="object-contain aspect-[18/20] w-[min(1.76vw,18px)] h-fit" src="/img/icons/icon-bill-orange.svg" alt="" />
                  <div className="prompt text-16">{kitchenCount}</div>
                </div>
                <div className="text-12 text-[var(--color-grey-2)]">บิล</div>
              </div>
            </div>
            <div className="flex flex-col shadow-sm justify-center gap-[min(0.59vw,6px)] min-w-[min(12.11vw,124px)] h-[min(5.66vw,58px)]  text-12 rounded-[min(0.49vw,5px)] px-[min(0.98vw,10px)]">
              <div className="text-[var(--color-grey-2)]">เวลาเฉลี่ยต่อออเดอร์</div>
              <div className="flex justify-between items-baseline ">
                <div className="flex items-baseline gap-[min(1.07vw,11px)]">
                  <img className="object-contain aspect-square w-[min(1.76vw,18px)] h-fit" src="/img/icons/icon-time-blue.svg" alt="" />
                  <div className="prompt text-16">{currentTimerAVG}</div>
                </div>
                <div className="text-12 text-[var(--color-grey-2)]">นาที</div>
              </div>
            </div>
            <div className="flex flex-col shadow-sm justify-center gap-[min(0.59vw,6px)] min-w-[min(12.70vw,130px)] h-[min(5.66vw,58px)]  text-12 rounded-[min(0.49vw,5px)] px-[min(0.68vw,7px)]">
              <div className="text-[var(--color-grey-2)]">ออเดอร์ที่ใช้เวลาสูงสุด</div>
              <div className="flex justify-between items-baseline ">
                <div className="flex items-baseline gap-[min(1.07vw,11px)]">
                  <img className="object-contain aspect-square w-[min(1.76vw,18px)] h-fit" src="/img/icons/icon-time-red.svg" alt="" />
                  <div className="prompt text-[#F95057] text-16">{currentTimerMAX}</div>
                </div>
                <div className="text-12 text-[var(--color-grey-2)]">นาที</div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex">
          {location.pathname !== "/checker" ? (
            <div className="min-w-[min(20.31vw,208px)] rounded-[min(0.29vw,3px)] bg-[var(--color-light-green)] text-[var(--color-green)] text-24 flex justify-center items-center mr-[min(2.44vw,25px)]">
              {currentKitchenName}
            </div>
          ) : (
            ""
          )}

          <div onClick={() => navigate(`/${businessSlug}/kitchen-history`)} className="cursor-pointer mr-[min(1.76vw,18px)]">
            <div className="flex justify-center items-center aspect-square h-fit w-[min(3.81vw,39px)] bg-[rgba(217,217,217,0.3)] rounded-[min(0.78vw,8px)]">
              <img className="object-contain aspect-square w-[min(2.54vw,26px)] h-fit" src="/img/icons/icon-history-grey.svg" alt="" />
            </div>

            <div className="text-12 text-[var(--color-grey-2)]">ประวัติ</div>
          </div>
          <div onClick={() => setIsLogoutOpen(!isLogoutOpen)} className="cursor-pointer aspect-square h-fit w-[min(4.10vw,42px)] relative">
            <AvartarHeader userInfo={{ avartar: "/img/avatar-male-pink.png" }} />
            {isLogoutOpen && (
              <div className="w-[min(19.43vw,199px)] h-0 absolute bottom-[calc(min(1.95vw,20px)*-1)] right-0">
                <AvartarLogoutBtn signOutHandler={handleClickLogout} />
              </div>
            )}
          </div>
        </div>
      </div>
      <LogoutConfirmModal isOpen={showLogoutModal} onClose={handleCancelLogout} onConfirm={handleLogout} />
    </>
  );
}
